import { render, staticRenderFns } from "./exportPosts.vue?vue&type=template&id=18dbd29b&scoped=true"
import script from "./exportPosts.vue?vue&type=script&lang=js"
export * from "./exportPosts.vue?vue&type=script&lang=js"
import style0 from "./exportPosts.vue?vue&type=style&index=0&id=18dbd29b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbd29b",
  null
  
)

export default component.exports